import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import de from 'vuetify/lib/locale/de';
import en from 'vuetify/lib/locale/en';
import defaultThemeLight from './themes/defaultLight';
import defaultThemeDark from './themes/defaultDark';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default value
  },
  lang: {
    locales: { de, en },
    current: navigator.language.split('-')[0] === 'en' ? 'en' : 'de',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: defaultThemeLight,
      dark: defaultThemeDark,
    },
  },
});
